import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name CoreX-BTC CRM 配置
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // CoreX-BTC 主题色
  colorPrimary: '#FA551D',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'CoreX-BTC CRM',
  pwa: true,
  logo: '/logo.png',
  iconfontUrl: '',
  token: {
    // 自定义主题
    sider: {
      colorMenuBackground: '#fff',
      colorTextMenu: '#000',
      colorTextMenuSelected: '#FA551D',
      colorBgMenuItemSelected: 'rgba(250, 85, 29, 0.1)',
    },
  },
};

export default Settings;
